// frontend/src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './layout/Layout';
import LoginPage from './pages/LoginPage';
import JuvenilesListPage from './pages/JuvenilesListPage';
import JuvenileDetailPage from './pages/JuvenileDetailPage';
import NewJuvenilePage from './pages/NewJuvenilePage';
import EditJuvenilePage from './pages/EditJuvenilePage';
import ReportingPage from './pages/ReportingPage';
import AuditLogPage from './pages/AuditLogPage';
import SearchResultsPage from './pages/SearchResultsPage';
import AdvancedSearchPage from './pages/AdvancedSearchPage';
import PrivateRoute from './components/PrivateRoute';
import UserManagementPage from './pages/UserManagementPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import DashboardPage from './pages/DashboardPage'; // Import DashboardPage

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Wrap all protected routes inside the PrivateRoute element */}
      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
         <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/juveniles" element={<JuvenilesListPage />} />
          <Route path="/juveniles/new" element={<NewJuvenilePage />} />
          <Route path="/juveniles/:id" element={<JuvenileDetailPage />} />
          <Route path="/juveniles/:id/edit" element={<EditJuvenilePage />} />
          <Route path="/reports" element={<ReportingPage />} />
          <Route path="/audit-logs" element={<AuditLogPage />} />
          <Route path="/admin/users" element={<UserManagementPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/advanced-search" element={<AdvancedSearchPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;